
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA en Bourgogne-Franche-Comté dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads en Bourgogne-Franche-Comté certifiée Google Partner, aide les entreprises régionales à accroître leur visibilité en ligne et à générer des prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads en Bourgogne-Franche-Comté dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads en Bourgogne-Franche-Comté certifiée Google Partner, aide les entreprises régionales à accroître leur visibilité en ligne et à générer des prospects qualifiés.",
        },
      ],
    };
  },
};
